import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatDialog} from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { AppComponent } from '../app.component';
import { DialogrejectconfirmComponent } from '../dialogrejectconfirm/dialogrejectconfirm.component';
import { CreateKaizen, KaizenCombined, KaizenState } from '../models/Kaizen';
import { YearlyProductFacts } from '../models/YearlyProductFacts';
import { ConfirmdialogApproveService } from '../Services/confirm-dialog-approve.service';
import { KaizenService } from '../Services/Kaizen.Service';
import { YearlyProductFactsService } from '../Services/YearlyProductFacts.Service';
import { AttachmentService } from '../Services/Attachment.Service';
import { Attachment } from '../models/Attachment';
import { LoaderService } from '../loader/loader.service';
import { firstValueFrom } from 'rxjs';
@Component({
    selector: 'app-cmdreview-kaizendetail',
    templateUrl: './cmdreview-kaizendetail.component.html',
    styleUrls: ['./cmdreview-kaizendetail.component.css'],
    standalone: false
})

export class CmdreviewKaizendetailComponent implements OnInit {
  yearlyProductFacts !: YearlyProductFacts[];
  createKaizen: CreateKaizen = new CreateKaizen();
  supportingMembers: string[] = [];
  KaizenCombined: KaizenCombined = new KaizenCombined();
  kaizenstate: KaizenState = new KaizenState();
  public KaizenCombinedAry: any;
  rejectForm!: UntypedFormGroup;
  yearlyProductFactsLoaded !: boolean;
  tableStartDate!: string;
  kaizenAttachments !: Attachment[];
  kaizenId: number = 0;
  progressChangedDisplayDate: string = "";
  statusDisplayDate: string = "";
  DisplayDateLabel: string = "";
  kaizenStatusDisplayString: string = "";
  timeZoneAbbreviation = new Date().toLocaleTimeString('en-us', { timeZoneName: 'short' }).split(' ')[2];
  impYear: string = '';
  impMonth: string = '';

  constructor(private router: Router, private route: ActivatedRoute, private confirmdialogservice: ConfirmdialogApproveService,
    private KaizenService: KaizenService, private yearlyProductService: YearlyProductFactsService, private AttachmentService: AttachmentService,
    private dialog: MatDialog, private appComp: AppComponent, private loaderService: LoaderService

  ) { }

  ngOnInit(): void {
    const role = localStorage.getItem(`adroleNormalized`);
    if ((role != `CMDApprover`) && (role != `CMDApproverPlus`)) {
      this.router.navigate([`./kaizens`]);
    }
    this.kaizenId = Number(this.route.snapshot.paramMap.get('id'));
    this.getKaizenDet();
  }
  getKaizenDet() {
    this.kaizenId = Number(this.route.snapshot.paramMap.get('id'));
    firstValueFrom(this.KaizenService.getKaizen(this.kaizenId)).then((data) => {
      this.createKaizen = data?.data ?? new CreateKaizen();
      this.supportingMembers = this.createKaizen.kaizenSupportingPerson;
      this.impYear = this.createKaizen.estimatedImplementationYear;
      this.impMonth = this.createKaizen.estimatedImplementationMonth;
      this.getAttachments();
    });

    firstValueFrom(this.KaizenService.getKaizenCombined(this.kaizenId)).then((data) => {
      this.KaizenCombinedAry = data;
      console.log('combi',data);
      this.KaizenCombined = this.KaizenCombinedAry.data[0];
      if (this.KaizenCombined.rankDecisionTiming) {
        var decisionDate = new Date(this.KaizenCombined.rankDecisionTiming);
        let formattedDate = new Intl.DateTimeFormat("en-US", {
          year: "numeric",
          month: "short",
          day: "2-digit",
        }).format(decisionDate);
        this.KaizenCombined.rankDecisionTimingString = formattedDate;
      }
      const kkeywords = this.KaizenCombinedAry.data[0].kaizenTags.split('|');
      this.KaizenCombined.keyword1 = kkeywords[0];
      this.KaizenCombined.keyword2 = kkeywords[1];
      this.KaizenCombined.keyword3 = kkeywords[2];
      this.KaizenCombined.keyword4 = kkeywords[3];
      this.KaizenCombined.keyword5 = kkeywords[4];
      this.tableStartDate = this.KaizenCombined.estimatedImplementationMonth + "-" + this.KaizenCombined.estimatedImplementationDay + "-" + this.KaizenCombined.estimatedImplementationYear;
      this.progressChangedDisplayDate = new Date(this.KaizenCombined.progressChangedOn + "Z").toLocaleString();

      //Decode the status strings  and dates to display status date
      if (this.KaizenCombined.kaizenStateID == "2") {
        this.kaizenStatusDisplayString = 'Submitted'
        this.DisplayDateLabel = 'Submitted On';
        this.statusDisplayDate = new Date(this.KaizenCombined.createdOn + "Z").toLocaleString() + " " + this.timeZoneAbbreviation;
      }
      else if (this.KaizenCombined.kaizenStateID == "3") {
        this.kaizenStatusDisplayString = 'PendingRevision'
        this.DisplayDateLabel = 'Pending Revision On';
        this.statusDisplayDate = new Date(this.KaizenCombined.pendingRevisionOn + "Z").toLocaleString() + " " + this.timeZoneAbbreviation;
      }
      else if (this.KaizenCombined.kaizenStateID == "4") {
        this.kaizenStatusDisplayString = 'Cost Confirmed'
        this.DisplayDateLabel = 'Cost Confirmed On';
        this.statusDisplayDate = new Date(this.KaizenCombined.costConfirmedOn + "Z").toLocaleString() + " " + this.timeZoneAbbreviation;
      }
      else if (this.KaizenCombined.kaizenStateID == "6") {
        this.kaizenStatusDisplayString = 'In progress'
        this.DisplayDateLabel = 'Progress Changed On';
        this.statusDisplayDate = new Date(this.KaizenCombined.progressChangedOn + "Z").toLocaleString() + " " + this.timeZoneAbbreviation;
      }
      else if (this.KaizenCombined.kaizenStateID == "9") {
        this.kaizenStatusDisplayString = 'Cancelled'
        this.DisplayDateLabel = 'Cancelled On';
        this.statusDisplayDate = new Date(this.KaizenCombined.progressChangedOn + "Z").toLocaleString() + " " + this.timeZoneAbbreviation;
      }
      else if (this.KaizenCombined.kaizenStateID == "10") {
        this.kaizenStatusDisplayString = 'Completed'
        this.DisplayDateLabel = 'Completed On';
        this.statusDisplayDate = new Date(this.KaizenCombined.progressChangedOn + "Z").toLocaleString() + " " + this.timeZoneAbbreviation;
      }
    });
  }

  RejectKaizen() {
    const id = Number(this.route.snapshot.paramMap.get('id'));
    this.dialog.open(DialogrejectconfirmComponent, {
      width: '40%',
      data: {
        id: id
      }
    }
    );
  }

  ApproveKaizen() {
    this.confirmdialogservice.openDialog().afterClosed().subscribe(res => {
      console.log(res);
      if (res) {
        const id = Number(this.route.snapshot.paramMap.get('id'));
        this.kaizenstate.KaizenId = id;
        this.kaizenstate.KaizenStateID = 4;
        this.kaizenstate.costConfirmedBy = this.appComp.ademail;
        firstValueFrom(this.KaizenService.updateKaizenStatus(this.kaizenstate)).then((data) => {
          this.router.navigate(['/cmdreview'])
            .then(() => {
              window.location.reload();
            });

        });
      }
    });
  }

  getAttachments(): void {
    firstValueFrom(this.AttachmentService.getAttachmentsByKaizenId(this.kaizenId)).then((data) => {
      this.kaizenAttachments = data?.data || [] ;
      //console.log(this.kaizenAttachments);
    })
  }

  downloadAttachment(attachmentName: string, kaizenId: number) {
    this.AttachmentService.viewFile(attachmentName, kaizenId).subscribe({
      next: results => {
        window.open(results, '_blank');
      },
      error: error => { console.log('There was an error!', error); }
    });
  }

  cancel() {
    this.router.navigate(['/cmdreview']);
  }
}